/** Situações dos mercados */
export interface MercadoSituacao {
    id: number,
    nome: string;
}

export const mercadoAtivo: MercadoSituacao = {id: 1, nome: 'Ativo'};
export const mercadoInativo: MercadoSituacao = {id: 2, nome: 'Inativo'};

export const mercadoSituacoes: MercadoSituacao[] = [
    mercadoAtivo,
    mercadoInativo
];

/** Verifica se a situação do mercado é Ativo */
export function isSituacaoAtivo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === mercadoAtivo.id;
}

/** Verifica se a situação do mercado é Inativo */
export function isSituacaoInativo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === mercadoInativo.id;
}
